/** 模型存储：模型来源、主数据卷、挂载路径 */
export const MAAS_MODEL_STORAGE_FIELD_KEYS = {
  model: 'mi.model',
  modelSources: 'mi.model.sources',
  modelName: 'mi.model.name',
  modelMountPath: 'mi.model.mountPath',
  modelSize: 'mi.model.size',
  modelCategory: 'mi.modelCategory',
  modelStorageMode: 'mi.modelStorageMode',
  primaryDataVolume: 'mi.primaryDataVolume',
  storageConfigured: 'mi.storageConfigured',
} as const;

export const MAAS_MODEL_STORAGE_FIELD_KEY_LIST = [
  MAAS_MODEL_STORAGE_FIELD_KEYS.model,
  MAAS_MODEL_STORAGE_FIELD_KEYS.modelSources,
  MAAS_MODEL_STORAGE_FIELD_KEYS.modelName,
  MAAS_MODEL_STORAGE_FIELD_KEYS.modelMountPath,
  MAAS_MODEL_STORAGE_FIELD_KEYS.modelSize,
  MAAS_MODEL_STORAGE_FIELD_KEYS.modelCategory,
  MAAS_MODEL_STORAGE_FIELD_KEYS.modelStorageMode,
  MAAS_MODEL_STORAGE_FIELD_KEYS.primaryDataVolume,
  MAAS_MODEL_STORAGE_FIELD_KEYS.storageConfigured,
] as const;
